((document, window, history) => {


	const pushState = history.pushState;
	const youTubeRegex = RegExp(/(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i);

	// cookie compliance banner
	function cookieCompliance() {
		if (document.querySelector('.site-farlo-ui-biscuit-banner__button')) {
			document.querySelector('.site-farlo-ui-biscuit-banner__button').addEventListener('click', (e) => {
				e.preventDefault();

				e.target.closest('.site-farlo-ui-biscuit-banner').classList.add('site-farlo-ui-biscuit-banner--hide');

				window._farlo.storage.set('cookieCompliance', 'true', 'cookie');
			});
		}

		if (document.querySelector('.site-farlo-ui-biscuit-banner__button--close')) {
			document.querySelector('.site-farlo-ui-biscuit-banner__button--close').addEventListener('click', (e) => {
				e.preventDefault();

				e.target.closest('.site-farlo-ui-biscuit-banner').classList.add('site-farlo-ui-biscuit-banner--hide');
			});
		}
	}

	// default navicon
	function navicon() {
		document.querySelector('.site-navigation__navicon').addEventListener('click', (e) => {
			e.preventDefault();
			e.currentTarget.classList.toggle('site-navigation__navicon--active');
			document.querySelector('.site-navigation').classList.toggle('site-navigation--active');
			document.body.classList.toggle('site-navigation--open');
		});
	}

	// default navigation subnav
	function navigation(submenu) {
		if (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0)) {
			window._farlo.helpers.getSiblings(submenu)[ 0 ].addEventListener('click', (e) => {
				if (!e.target.classList.contains('site-navigation__menu-item--active')) {
					e.preventDefault();

					e.currentTarget.classList.add('site-navigation__menu-item--active');
					submenu.classList.add('site-navigation__sub-menu--active');

					for (let i = 0; i < window._farlo.helpers.getSiblings(e.currentTarget.parentNode).length; i += 1) {
						if (window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 0 ] && window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 0 ].classList.contains('site-navigation__menu-item--active')) {
							window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 0 ].classList.remove('site-navigation__menu-item--active');
						}

						if (window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 1 ] && window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 1 ].classList.contains('site-navigation__sub-menu--active')) {
							window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 1 ].classList.remove('site-navigation__sub-menu--active');
						}
					}
				} else {
					return true;
				}
			});
		} else {
			submenu.parentNode.addEventListener('mouseover', () => {
				if (submenu.parentNode.querySelector('.site-navigation__sub-menu--active')) {
					submenu.parentNode.querySelectorAll('.site-navigation__sub-menu--active').forEach((_sel) => {
						_sel.classList.remove('site-navigation__sub-menu--active');
						_sel.parentNode.classList.remove('site-navigation__menu-item--active');
					});
				}
				submenu.classList.add('site-navigation__sub-menu--active');
				submenu.parentNode.classList.add('site-navigation__menu-item--active');
			});

			submenu.parentNode.addEventListener('mouseout', () => {
				submenu.classList.remove('site-navigation__sub-menu--active');
				submenu.parentNode.classList.remove('site-navigation__menu-item--active');
			});
		}
	}



	let farloUiSignupForm = null;

	function farloUiMcSignup(_sel) {

		if (typeof _sel.target !== 'undefined' && _sel.target !== null) {
			if (_sel.target.dataset.crmButtonFor !== '') {
				farloUiSignupForm = new FarloUiMc(_sel.target.dataset.crmButtonFor);
			}
		} else if (farloUiSignupForm) {
			farloUiSignupForm.toggleForm();
		} else {
			farloUiSignupForm = new FarloUiMc(_sel.id);
		}
	}

	function faqs() {
		const accordions = document.querySelectorAll('.site-faqs__accordion-faq');

		const openAccordion = (accordion) => {
			const answer = accordion.querySelector('.site-faqs__accordion-answer');
			accordion.classList.add('site-faqs__accordion-faq--active');
			answer.style.maxHeight = answer.scrollHeight + 'px';
		};

		const closeAccordion = (accordion) => {
			const answer = accordion.querySelector('.site-faqs__accordion-answer');
			accordion.classList.remove('site-faqs__accordion-faq--active');
			answer.style.maxHeight = null;
		};

		accordions.forEach((accordion) => {
			const question = accordion.querySelector('.site-faqs__accordion-question');
			const answer = accordion.querySelector('.site-faqs__accordion-answer');

			question.onclick = () => {
				if (answer.style.maxHeight) {
					closeAccordion(accordion);
				} else {
					accordions.forEach((acc) => closeAccordion(acc));
					openAccordion(accordion);
				}
			};
		});
	}

	function farloUiLightbox(elem, div) {
		if (elem.querySelector('.wp-block-image')) {
			elem.querySelectorAll('.wp-block-image').forEach((_sel) => {
				_sel.addEventListener('click', (e) => {
					const clonedEmbed = e.currentTarget.cloneNode(true);
					document.body.classList.add('body--farlo-ui-lightbox-open');
					div.querySelector('.site-farlo-ui-lightbox__inner-content').innerHTML = '';
					div.querySelector('.site-farlo-ui-lightbox__inner-content').appendChild(clonedEmbed);
					div.classList.add('site-farlo-ui-lightbox--active');
				});
			});
		}

		if ((elem.nextElementSibling && elem.nextElementSibling.value) || (elem.querySelector('.site-farlo-ui-lightbox__html') && elem.querySelector('.site-farlo-ui-lightbox__html').value)) {
			elem.addEventListener('click', function(e) {
				e.preventDefault();
				e.stopPropagation();
				document.body.classList.add('body--farlo-ui-lightbox-open');
				div.querySelector('.site-farlo-ui-lightbox__inner-content').classList.add('dynamic');

				if ((e.currentTarget.nextElementSibling && e.currentTarget.nextElementSibling.value)) {
					div.querySelector('.site-farlo-ui-lightbox__inner-content').innerHTML = e.currentTarget.nextElementSibling.value;
				} else if (e.currentTarget.querySelector('.site-farlo-ui-lightbox__html') && e.currentTarget.querySelector('.site-farlo-ui-lightbox__html').value) {
					div.querySelector('.site-farlo-ui-lightbox__inner-content').innerHTML = e.currentTarget.querySelector('.site-farlo-ui-lightbox__html').value;
				}
				div.classList.add('site-farlo-ui-lightbox--active');
			});
		}

		if (elem.querySelector('a[href*="youtu.be"]')) {
			elem.querySelector('a[href*="youtu.be"]').addEventListener('click', function(e) {
				e.preventDefault();
				document.body.classList.add('body--farlo-ui-lightbox-open');
				div.querySelector('.site-farlo-ui-lightbox__inner-content').innerHTML = '<iframe class="farlo-ui-lightbox__inner-content-iframe" src="https://www.youtube-nocookie.com/embed/' + e.target.href.match(youTubeRegex)[ 1 ] + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
				div.classList.add('site-farlo-ui-lightbox--active');
			});
		}

		if (div.querySelector('.site-farlo-ui-lightbox__button-close')) {
			div.querySelector('.site-farlo-ui-lightbox__button-close').addEventListener('click', function(e) {
				e.preventDefault();
				document.body.classList.remove('body--farlo-ui-lightbox-open');
				e.currentTarget.closest('.site-farlo-ui-lightbox').classList.remove('site-farlo-ui-lightbox--active');
				if (div.querySelector('.site-farlo-ui-lightbox__inner-content.dynamic')) {
					div.querySelector('.site-farlo-ui-lightbox__inner-content').classList.remove('dynamic');
				}
				div.querySelector('.site-farlo-ui-lightbox__inner-content').innerHTML = '';

				if (elem.classList.contains('site-geo-targeting')) {
					window._farlo.storage.set('geotargeted', 'true', 'cookie');
				}
			});
		}
	}

	function locationTabs() {
		const buttons = document.querySelectorAll(".venue-location__button");
		const panels = document.querySelectorAll(".venue-location__panel");
	  
		// Set the first button and panel as active on page load
		buttons[0].classList.add("venue-location__button--active");
		panels[0].classList.add("venue-location__panel--active");
	  
		buttons.forEach((button, index) => {
		  button.addEventListener("click", () => {
			// Hide all panels
			panels.forEach(panel => {
			  panel.classList.remove("venue-location__panel--active");
			});
	  
			// Show the corresponding panel
			panels[index].classList.add("venue-location__panel--active");
	  
			// Remove active class from all buttons
			buttons.forEach(btn => {
			  btn.classList.remove("venue-location__button--active");
			});
	  
			// Add active class to clicked button
			button.classList.add("venue-location__button--active");
	  
			// Update the URL with the panel's ID
			const panelId = panels[index].id;
			history.pushState({}, "", `#${panelId}`);
		  });
		});
	  
		// Check if there's a panel ID in the URL and show that panel
		const urlPanelId = window.location.hash.substring(1);
		if (urlPanelId) {
		  const panelIndex = Array.from(panels).findIndex(panel => panel.id === urlPanelId);
		  if (panelIndex !== -1) {
			// Hide all panels
			panels.forEach(panel => {
			  panel.classList.remove("venue-location__panel--active");
			});
	  
			// Show the corresponding panel
			panels[panelIndex].classList.add("venue-location__panel--active");
	  
			// Remove active class from all buttons
			buttons.forEach(btn => {
			  btn.classList.remove("venue-location__button--active");
			});
	  
			// Add active class to corresponding button
			buttons[panelIndex].classList.add("venue-location__button--active");
		  }
		}
	}

	function genericLightbox() {
		var toggleButtons = document.querySelectorAll(".farlo-ui-lightbox-generic__toggle");
		// Loop through each toggle button and add a click event listener
		toggleButtons.forEach(function (button) {
			button.addEventListener("click", function (e) {
				e.preventDefault();
			// Get the value of the "data-target" attribute
			var targetId = button.getAttribute("data-target");

			// Find the corresponding div element by ID
			var targetDiv = document.querySelector(targetId);
			document.body.classList.add('body--farlo-ui-lightbox-open');

			// Check if the target div exists
			if (targetDiv) {
				// Set the style of the target div to "display: block"
				targetDiv.style.display = "flex";
				targetDiv.classList.add('farlo-ui-lightbox--active');
			}
			});
		});

		document.querySelectorAll('.farlo-ui-lightbox__close-button').forEach((_sel) => {
			_sel.addEventListener('click', (e) => {
				e.preventDefault();
				document.body.classList.remove('body--farlo-ui-lightbox-open');

				e.currentTarget.parentNode.classList.remove('farlo-ui-lightbox--active');
			});
		});

	  }

	  function smoothScroll(_sel) {
		_sel.addEventListener('click', function(e) {
			if (e.target.classList.contains('tour-date-action')) {
				// If the clicked element has the class 'tour-date-action', continue and follow the link as normal
				return;
			}
			
			e.preventDefault();
	
			if (document.querySelector('.site-navigation__navicon--active') && document.body.classList.contains('site-navigation--open')) {
				document.querySelector('.site-navigation__navicon').click();
			}
	
			if (e.target.parentNode.parentNode) {
				e.target.parentNode.parentNode.classList.remove('site-navigation__sub-menu--active');
			}
	
			if (e.target.parentNode.parentNode.parentNode) {
				e.target.parentNode.parentNode.parentNode.querySelector('a').classList.remove('site-navigation__menu-item--active');
			}
	
			var href = e.target.href || e.target.closest('a').href; // Get href from target or its ancestor
	
			if (href && href.includes('#')) {
				var targetId = href.split('#')[1];
				var targetElement = document.getElementById(targetId);
				if (targetElement) {
					targetElement.scrollIntoView({ behavior: 'smooth' });
				}
			} else {
				window.location.href = href || e.target.closest('a').href; // Fall back to the href of the target or its ancestor
			}
		});
	}
	
	

	history.pushState = function(state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};

	document.addEventListener('DOMContentLoaded', () => {
		const lightboxEmbed = document.querySelectorAll('.site-video-embed-group, .site-farlo-ui-lightbox__toggle, .wp-block-gallery');
		let div;
		let divInner;
		let divInnerContent;
		let divClose;

		if (document.querySelector('.site-navigation__navicon')) {
			navicon();
		}

		if (document.querySelector('.site-navigation__sub-menu')) {
			document.querySelectorAll('.site-navigation__sub-menu').forEach((_sel) => {
				navigation(_sel);
			});
		}

		if (document.querySelector('.site-farlo-ui-biscuit-banner')) {
			cookieCompliance();
		}

		if (lightboxEmbed.length > 0) {
			div = document.createElement('div');
			divInner = document.createElement('div');
			divInnerContent = document.createElement('div');
			divClose = document.createElement('button');
			div.className = 'site-farlo-ui-lightbox';
			divInner.className = 'site-farlo-ui-lightbox__inner';
			divInnerContent.className = 'site-farlo-ui-lightbox__inner-content';
			divClose.className = 'site-farlo-ui-lightbox__button-close';

			document.body.appendChild(div);
			document.querySelector('.site-farlo-ui-lightbox').appendChild(divInner);
			document.querySelector('.site-farlo-ui-lightbox__inner').appendChild(divInnerContent);
			document.querySelector('.site-farlo-ui-lightbox__inner').appendChild(divClose);

			lightboxEmbed.forEach(function(elem) {
				farloUiLightbox(elem, div);
			});
		}

		document.querySelectorAll('a[href*="#"]').forEach((_sel) => {
			smoothScroll(_sel);
		});

		if (document.querySelector('.site-faqs')) {
			faqs();
		}

		if (document.querySelector('.venue-location__button')){
			// locationTabs();
		}

		if (document.querySelector('.site-farlo-ui-crm--inline')) {
			document.querySelectorAll('[farlo-ui="crm"]').forEach((_sel) => {
				farloUiMcSignup(_sel);
			});
		}

		if (document.querySelector('.site-farlo-ui-crm__toggle')) {
			document.querySelectorAll('.site-farlo-ui-crm__toggle').forEach((_sel) => {
				_sel.addEventListener('click', (e) => {
					e.preventDefault();
					e.stopImmediatePropagation();
					farloUiMcSignup(e);
				});
			});
		}

		if (document.querySelector('.site-farlo-ui-ticket-calendar')) {
			document.querySelectorAll('[farlo-ui="calendar"]').forEach((_sel) => {
				_sel.farloUiTicketCalendar(_sel);
			});
		}

		genericLightbox();

	});

	document.addEventListener('DOMContentLoaded', () => {
		if (document.querySelector('.site-farlo-ui-revolver-carousel')) {
			document.querySelectorAll('[farlo-ui="carousel"]').forEach((_sel) => {
				_sel.farloUiRevolverCarousel();
			});
		}

		if (document.querySelector('.site-farlo-ui-lightbox')) {
			document.querySelectorAll('[farlo-ui="lightbox"]').forEach((_sel) => {
				_sel.farloUiLightbox();
			});
		}
	});

	if (typeof navigator !== 'undefined') {
		navigator.serviceWorker.getRegistrations().then(function(registrations) {
			for (const registration of registrations) {
				registration.unregister();
			}
		});
	}

	function formNumberInputs(_sel) {
		const upButton = document.createElement('button');
		const downButton = document.createElement('button');
		window._farlo.helpers.wrapElement(_sel, document.createElement('div'), 'site-form-field__input-number');
		upButton.className = 'site-form-field__input-number-button site-form-field__input-number-button--up';
		upButton.innerHTML = "&plus;";
		downButton.className = 'site-form-field__input-number-button site-form-field__input-number-button--down';	
		downButton.innerHTML = "&minus;";

		_sel.parentNode.appendChild(upButton);
		_sel.parentNode.appendChild(downButton);

		// reset step attribute to prevent erroring
		if (_sel.getAttribute('step') && _sel.getAttribute('step') === 'any') {
			_sel.setAttribute('step', '1');
		}

		upButton.addEventListener('click', (e) => {
			e.preventDefault();
			e.currentTarget.parentNode.querySelector('input').stepUp();
			if (window.farlo_red61) {
				if (farlo_params.is_basket) {
					window.farlo_red61.booking.update_cart();
				} else {
					window.farlo_red61.booking.build_summary();
				}
			}
		});
		downButton.addEventListener('click', (e) => {
			e.preventDefault();
			e.currentTarget.parentNode.querySelector('input').stepDown();
			if (window.farlo_red61) {
				if (farlo_params.is_basket) {
					window.farlo_red61.booking.update_cart();
				} else {
					window.farlo_red61.booking.build_summary();
				}
			}
		});
	}
	document.querySelectorAll('input[type="number"]').forEach((_sel) => {
		formNumberInputs(_sel);
	});


})(document, window, history);
